<template>
    <div>
      <button class="button is-fullwidth" @click="edit()">ДОБАВИТЬ ПО</button>
      <div class="column is-8 is-offset-2">
        <div v-if="showForm">
          <b-field label="Название">
            <b-input v-model='app.title' required></b-input>
          </b-field>
          <b-field label="GrottBjörn ID">
            <b-input v-model='app.sourceId' required></b-input>
          </b-field>
          <b-field label="Описание">
            <textarea class="textarea" v-model="app.description" required></textarea>
          </b-field>
          <div v-if="!showFileForm">
            <b-field label="Файлы" />
            <ul class="list">
              <li v-for="(fileItem, idx) in app.files" v-bind:key="fileItem.id">
                <a v-if="fileItem.path" :href="fileItem.path" target="_blank" download>{{ fileItem.title }}</a>
                <span v-else>{{ fileItem.title }}</span>
                <span class="is-pulled-right">
                  <a @click.stop="editFile(fileItem.id || idx)">Редактировать</a>
                  <a @click.stop="delFile(fileItem.id || idx)">Удалить</a>
                </span>
              </li>
            </ul>
          </div>
          <hr>
          
          <a v-if="!showFileForm" @click="editFile()">Добавить файл</a>
          
          <div v-if="showFileForm" class="column is-8 is-offset-2">
            <div class="centered">
              <b-switch v-model='file.isLink' @change='rerender()'>Это ссылка</b-switch>
            </div>

            <b-field label="Название">
              <b-input v-model='file.title' required></b-input>
            </b-field>

            <b-field v-if='file.isLink' label="Ссылка на файл">
              <b-input v-model='file.link' required></b-input>
            </b-field>

            <b-field v-if="!file.isLink && file.path" label="Текущий файл">
              {{ file.path }}
            </b-field>
            <b-field v-if="!file.isLink" :label="fileExist ? 'Новый файл' : 'Файл'">
              <input class="input" type="file" ref="fileInput" @change="setFile"/>
            </b-field>
            <button class="button is-fullwidth is-success" @click="saveFile">{{ fileExist ? 'СОХРАНИТЬ ФАЙЛ' : 'ДОБАВИТЬ ФАЙЛ' }}</button>
            <button class="button is-fullwidth" @click="resetFileForm">ОТМЕНИТЬ</button>
          </div>
          <br>
          <br>
          <button class="button is-fullwidth is-success" :disabled="waiting" @click="save" >{{ waiting ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
          <button class="button is-fullwidth" @click="resetForm">ОТМЕНИТЬ</button>
        </div>
        <ul v-else class="list">
          <li v-for="appItem in apps" class="box" @click="edit(appItem.id)" v-bind:key="appItem.id">
            <strong>{{ appItem.title }}</strong>
            <button class="delete is-pulled-right" @click.stop="del(appItem.id)"></button>
            <p>{{ appItem.description }}</p>
            <ul>
              <li v-for="item in appItem.files" v-bind:key="item.id">
                <strong>{{ item.title }}</strong>
              </li>
            </ul>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Apps',
  data () {
    return {
      showForm: false,
      showFileForm: false,
      appId: '',
      fileId: '',
      filesToDelete: new Set(),
      waiting: false,
      file: null
    }
  },

  computed: {
    ...mapState({
      apps: state => state.software.apps
    }),
    fileExist () {
      return (this.fileId || this.fileId === 0)
    },
    app () {
      return this.appId
        ? {
          ...this.apps.find(app => app.id === this.appId)
        }
        : {
          title: '',
          description: '',
          files: []
        }
    }
  },
  created () {
    this.getApps()
  },
  methods: {
    ...mapActions(['getApps', 'saveApp', 'deleteApp', 'addFile', 'saveFile', 'deleteFile']),
    edit (id) {
      this.appId = id
      this.showForm = true
    },
    save () {
      if (this.app.title) {
        this.waiting = true
        this.saveApp({
          app: this.app,
          toDelete: this.filesToDelete
        })
        .then(() => {
          this.resetForm()
          this.waiting = false
        })
      }
    },
    del (id) {
      this.$dialog.confirm({
        message: 'Действительно удалить?',
        onConfirm: () => {
          this.deleteApp(id)
          .then(() => this.$toast.open({
            message: 'ПО удалёно'
          }))
        }
      })
    },
    fileCheck () {
      if (this.fileId || this.fileId === 0) { // fileId can be first index(0) from files array
        if (this.app.files.find(file => file.id === this.fileId)) {
          this.file = { ...this.app.files.find(file => file.id === this.fileId) }
        } else {
          this.file = { ...this.app.files[this.fileId] }
        }
      } else {
        this.file = {
          title: '',
          path: '',
          file: '',
          isLink: false,
          link: ''
        }
      }
    },

    resetForm () {
      this.waiting = false
      this.appId = ''
      this.showForm = false
    },
    editFile (id) {
      this.fileId = id
      this.fileCheck()
      this.showFileForm = true
    },
    setFile (event) {
      this.file.file = event.target.files[0]
      this.file.path = event.target.files[0].name
    },
    saveFile () {
      if (this.file.title && (this.file.path || this.file.file || this.file.link)) {
        if (this.fileId || this.fileId === 0) {
          let file = this.app.files.find(file => file.id === this.fileId)
          if (file) {
            let idx = this.app.files.findIndex(f => f.id === file.id)
            this.app.files[idx] = this.file
          } else {
            this.app.files[this.fileId] = this.file
          }
        } else {
          this.appId // if appId exists use action to avoid state mutation from components
            ? this.addFile({
              appId: this.appId,
              file: this.file
            })
            : this.app.files.push(this.file)
        }
        this.resetFileForm()
      }
    },
    delFile (id) {
      let file = this.app.files.find(file => file.id === id)
      this.$dialog.confirm({
        message: 'Действительно удалить?',
        onConfirm: () => {
          if (file) {
            this.deleteFile(file.id)
            .then(() => this.$toast.open({ message: 'Файл удалён' }))
          } else {
            this.app.files.splice(id, 1)
            this.$toast.open({ message: 'Файл удалён' })
          }
        }
      })
    },
    resetFileForm () {
      this.fileId = ''
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
      this.showFileForm = false
    },

    rerender () {
      this.$forceUpdate()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Item.vue?61dbdd09